module.exports = __webpack_public_path__ + "img/pos2.a0a38579.jpg";